import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { BrowserRouter, Route, Switch, Link, Redirect} from 'react-router-dom';
// Importação do Bootstrap
import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Loading from '../Miscelania/Loading';
// Helpers de formulário
import Topo from '../Layout/Topo';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import RequestApi from '../Miscelania/RequestApi';
import Overlay from '../Miscelania/Overlay';

class ConfiguracoesProvasDificuldade extends Component {
  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      lista_dificuldades: [],
      name: '',
      dados: [],
      name_edit: '',
      setting_level_id: '',
      dados_modal: [],
      qtd_edit: null,
      qtd_questoes: '',
      time_limit: '',
      qtd_questoes_edit: '',
      time_limit_edit: '',
      setting_difficulty_id: null,
      setting_level_difficulty_id: null,
    };
    //bind geral
    // handleChange e handleChangeSelect necessitam do bind nas tags
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.adicionarDificuldade = this.adicionarDificuldade.bind(this);
    this.adicionarPercentual = this.adicionarPercentual.bind(this);
    this.editarPercentual = this.editarPercentual.bind(this);
    this.showModal = this.showModal.bind(this);
    this.showCoeficientModal = this.showCoeficientModal.bind(this);
    this.botaoEdicao = this.botaoEdicao.bind(this);
    this.editarDificuldade = this.editarDificuldade.bind(this);
    this.deletarLinhaModal = this.deletarLinhaModal.bind(this);
    this.deletarModal = this.deletarModal.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
  }


  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData(e) {
    var url = config.get('api') + '/provas/dificuldades';
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/categorias');
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }


  adicionarDificuldade(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var dados_salvar = {
      name: this.state.name,
      time_limit: this.state.time_limit,
      qtd_questoes: this.state.qtd_questoes,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/provas/dificuldades/adicionar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          var dados_temp = self.state.dados;
          dados_temp.push(responseJson.data);
          self.setState({dados: dados_temp});        
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  editarPercentual(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var dados_salvar = {
      id: this.state.edit_setting_level_difficulty_id,
      setting_difficulty_id: this.state.edit_setting_level_difficulty_setting_difficulty_id,
      qtd_difficulty: this.state.edit_setting_level_difficulty_qtd_difficulty,
      setting_level_id: this.state.setting_level_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/dificuldade/questao/editar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {

        self.refs.request_api.validate(responseJson);

        if (responseJson.status === 'success') {
          self.setState({dados_modal: responseJson.data});
        }

        self.handleAlert(responseJson.message, responseJson.status, 'open');

      }).catch((error) => {
        console.error(error);
      });
    });

  }

  adicionarPercentual(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var dados_salvar = {
      setting_level_id: this.state.setting_level_id,
      setting_difficulty_id: this.state.setting_difficulty_id,
      qtd_difficulty: this.state.qtd_difficulty,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/dificuldade/questoes/adicionar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);

        if (responseJson.status === 'success') {
          self.setState({dados_modal: responseJson.data});
        }

        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  editarDificuldade(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var dados_salvar = {
      id: this.state.setting_level_id,
      name: this.state.name_edit,
      time_limit: this.state.time_limit_edit,
      qtd_questoes: this.state.qtd_questoes_edit,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/dificuldade/editar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {

        self.refs.request_api.validate(responseJson);

        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }

        self.handleAlert(responseJson.message, responseJson.status, 'open');

      }).catch((error) => {
        console.error(error);
      });
    });

  }


  showModal(event) {
    var target = event.currentTarget.value;
    this.handleAlert('', '', 'open');
    
    /**
     * busco dados para formulário de edição em modal
     */
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/dificuldade/view/'+target, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({
            setting_level_id: target,
            name_edit: responseJson.data.name,
            time_limit_edit: responseJson.data.time_limit,
            qtd_questoes_edit: responseJson.data.qtd_questoes,
          });

        }
      }).catch((error) => {
        console.error(error);
      });
    });
    /**
     * busco dados para formulário de edição de coeficiente em modal
     */
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questoes/dificuldade/listar', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_dificuldades: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });

    /**
     * busco dados para listagem de edição de coeficiente em modal
     */
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/dificuldade/questoes/'+target, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ modal: true });
          self.setState({dados_modal: responseJson.data});
          self.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  showCoeficientModal(event) {
    var target = event.currentTarget.value;
    this.handleAlert('', '', 'open');
    
    /**
     * busco dados para formulário de edição de coeficiente em modal
     */
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/dificuldade/questao/view/'+target, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({
            edit_setting_level_difficulty_setting_difficulty_id: responseJson.data.setting_difficulty_id,
            edit_setting_level_difficulty_id: responseJson.data.id,
            edit_setting_level_difficulty_qtd_difficulty: responseJson.data.qtd_difficulty,
            modal_edit_percent: true,
          });
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  ActionsButtons (cell, row, enumObject, index) {
    var variavel = (
      <div>
        <button className="btn btn-sm btn-primary" value={cell} onClick={this.showCoeficientModal}>
          <i className="fa fa-fw fa-pencil"></i>
        </button>
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletarModal}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return variavel;
  }

  deletarModal (event) {
    var setting_level_difficulty_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse percentual?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/dificuldade/questoes/deletar/'+ setting_level_difficulty_id, { 
          method: 'DELETE', 
          mode: 'cors', 
          headers: value,
        })
        .then((response) => response.json())
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.handleAlert(responseJson.message, responseJson.status, 'open');
          if (responseJson.status === 'success') {
            self.deletarLinhaModal(setting_level_difficulty_id);
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deletarLinhaModal(setting_level_difficulty_id) {
    var dados = this.state.dados_modal;
    dados.map(function(dado, index){
      if (dado.id == setting_level_difficulty_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({status_loading: 0, dados_modal: dados});
  }

  botaoEdicao (cell, row) {
    var botao = (
      <button className="btn btn-primary btn-sm" value={cell} onClick={this.showModal}>
        <i className="fa fa-fw fa-pencil"></i>
      </button>
    );

    return botao;
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      <div className="row">
        <div className="col-md-3">
          <h3 className="page-title">Cadastrar dificuldade de provas</h3>
          <hr/>
          <form onSubmit={this.adicionarDificuldade}>
            <div className="form-group">
              <label>Nome:</label>
              <input type="text" name="name" className="form-control" placeholder="Nome da dificuldade" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>     
            <div className="form-group">
              <label>Quantidade de questões:</label>
              <InputMask value={this.state.qtd_questoes}  maskChar={null} name="qtd_questoes" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'qtd_questoes')} placeholder="Somente números" />
            </div>
            <div className="form-group">
              <label>Tempo de prova:</label>
              <InputMask value={this.state.time_limit}  maskChar={null} name="time_limit" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'time_limit')} placeholder="Tempo de prova em minutos" />
            </div>
            <div className="form-group">
              <button className="btn btn-primary btn-block" type="submit"><i className="fa fa-fw fa-save"></i> Adicionar dificuldade</button>
            </div>
          </form>
        </div>      
        <div className="col-md-9">
          <h3 className="page-title">Lista de dificuldades de provas</h3>
          <hr/>
          <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há dificuldade de prova cadastrada'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

            <TableHeaderColumn dataField="name" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='300'>Nome</TableHeaderColumn>

            <TableHeaderColumn dataField="time_limit" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='300'>Tempo de prova</TableHeaderColumn>

            <TableHeaderColumn dataField="qtd_questoes" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='300'>Quantidade de questões</TableHeaderColumn>

            <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicao} width='80'>Ações</TableHeaderColumn>

          </BootstrapTable>
        </div>
      </div>
    </div>
  </div>
  <Modal show={this.state.modal} bsSize={'large'} aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
      <h4 className="pull-left">Editar dificuldade de prova</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.editarDificuldade}>
        <input type="hidden" name="id" className="form-control" value={this.state.setting_level_id} />
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label>Nome:</label>
              <input type="text" name="name" className="form-control" placeholder="Nome da dificuldade" value={this.state.name_edit} onChange={this.handleChange.bind(this, 'name_edit')} />
            </div> 
            <div className="form-group">
              <label>Quantidade de questões:</label>
              <InputMask value={this.state.qtd_questoes_edit}  maskChar={null} name="qtd_questoes" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'qtd_questoes_edit')} placeholder="Somente números" />
            </div>
            <div className="form-group">
              <label>Tempo de prova:</label>
              <InputMask value={this.state.time_limit_edit}  maskChar={null} name="time_limit" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'time_limit_edit')} placeholder="Tempo de prova em minutos" />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <button className="btn btn-primary btn-block btn-inline" type="submit"><i className="fa fa-fw fa-save"></i> Editar dificuldade</button>
            </div>
          </div>
        </div>
      </form>
      <hr/>
      <h4>Adicionar coeficiente de dificuldade de questões por dificuldade de prova</h4>
      <hr/>
      <form onSubmit={this.adicionarPercentual}>
        <input type="hidden" name="setting_level_id" className="form-control" value={this.state.setting_level_id} />
        <input type="hidden" name="id" className="form-control" value={this.state.setting_level_id} />
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Dificuldade de questão:</label>
              <Select
                className="form-field-name"
                name="setting_difficulty_id"
                value={this.state.setting_difficulty_id}
                searchable={true}
                placeholder={'Selecione a dificuldade'}
                onChange={this.handleSelectChange.bind(this, 'setting_difficulty_id')}
                options={this.state.lista_dificuldades}
              />    
            </div>     
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Percentual de questões:</label>
              <InputMask value={this.state.qtd_difficulty}  maskChar={null} name="qtd_difficulty" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'qtd_difficulty')} placeholder="Somente números" />
            </div>     
          </div>
        </div>
        <div className="form-group">
          <button className="btn btn-primary btn-block" type="submit"><i className="fa fa-fw fa-save"></i> Adicionar dificuldade</button>
        </div>
      </form>
      <hr/>
      <h4>Coeficientes de dificuldade de questões por dificuldade de prova</h4>
      <hr/>
      <BootstrapTable data={this.state.dados_modal} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há coeficiente de questão cadastrada'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="nome" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='300'>Nome</TableHeaderColumn>

        <TableHeaderColumn dataField="percentual" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='300'>Percentual</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='80'>Ações</TableHeaderColumn>

      </BootstrapTable>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={this.state.modal_edit_percent} bsSize={'small'} aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_edit_percent: false })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Header>
    <Modal.Body>
      <h4>Editar percentual de dificuldade de questões por dificuldade de prova</h4>
      <hr/>
      <form onSubmit={this.editarPercentual}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Dificuldade de questão:</label>
              <Select
                disabled
                className="form-field-name"
                name="edit_setting_level_difficulty_setting_difficulty_id"
                value={this.state.edit_setting_level_difficulty_setting_difficulty_id}
                searchable={true}
                onChange={this.handleSelectChange.bind(this, 'edit_setting_level_difficulty_setting_difficulty_id')}
                options={this.state.lista_dificuldades}
              />    
            </div>     
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Percentual de questões:</label>
              <InputMask value={this.state.edit_setting_level_difficulty_qtd_difficulty}  maskChar={null} name="edit_setting_level_difficulty_qtd_difficulty" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'edit_setting_level_difficulty_qtd_difficulty')} placeholder="Somente números" />
            </div>     
          </div>
        </div>
        <div className="form-group">
          <button className="btn btn-primary btn-block" type="submit"><i className="fa fa-fw fa-save"></i> Editar percentual</button>
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_edit_percent: false })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default ConfiguracoesProvasDificuldade;



// WEBPACK FOOTER //
// ./src/Components/Configuracoes/ConfiguracoesProvasDificuldade.js